"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var N3 = require("n3");
function parseTurtleText(turtleText) {
    return new Promise(function (resolve, reject) {
        var triples = [];
        N3.Parser().parse(turtleText, function (error, triple, hash) {
            if (error) {
                reject(error);
            }
            else if (triple) {
                triples.push({
                    subject: n3toRdfNode(triple.subject),
                    predicate: n3toRdfNode(triple.predicate),
                    object: n3toRdfNode(triple.object),
                });
            }
            else {
                resolve(triples);
            }
        });
    });
}
exports.parseTurtleText = parseTurtleText;
function n3toRdfNode(entity) {
    if (N3.Util.isLiteral(entity)) {
        return {
            type: 'literal',
            value: N3.Util.getLiteralValue(entity),
            datatype: N3.Util.getLiteralType(entity),
            'xml:lang': N3.Util.getLiteralLanguage(entity),
        };
    }
    else {
        return { type: 'uri', value: entity };
    }
}
exports.n3toRdfNode = n3toRdfNode;
